/* import
---------------------------------------------------------- */
import Lenis from '@studio-freight/lenis';
import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

/* Webフォント
---------------------------------------------------------- */
const webfont = () => {

	window.WebFontConfig = {
		google: {
			families: [
				'Roboto+Condensed:700',
				'Noto+Sans+JP:400,500,700',
				'Noto+Serif+JP:400,500',
				// 'GFS+Didot:400',
			],
		},
		active: () => {
			sessionStorage.fonts = true;
		},
	};
	(() => {
		let wf = document.createElement('script');
		wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
		wf.type = 'text/javascript';
		wf.async = 'true';
		let s = document.getElementsByTagName('script')[0];
		s.parentNode.insertBefore(wf, s);
	})();
};

/* グローバルナビ
---------------------------------------------------------- */
const gnavAction = () => {
	const body = document.body;
	const gnavOpenClass = 'is-nav-opened';
	const gnavCloseClass = 'is-nav-closed';
	const gnav = document.getElementById('gnav');

	window.addEventListener('touchmove', (e) => {
		if (body.classList.contains(gnavOpenClass) && e.target === gnav) {
			e.preventDefault();
		} else {
			e.stopPropagation();
		}
	}, { passive: false });

	if (body.classList.contains(gnavOpenClass)) {
		body.classList.remove(gnavOpenClass);
		body.classList.add(gnavCloseClass);
	} else {
		body.classList.remove(gnavCloseClass);
		body.classList.add(gnavOpenClass);
	}
};

const gnavToggle = () => {
	const gnavToggle = document.querySelectorAll('.js-gnav-toggle');
	const overlay = document.getElementById('overlay');

	// ハンバーガーメニュークリック
	if (gnavToggle !== null) {
		Array.prototype.forEach.call(gnavToggle, (el) => {
			el.addEventListener('click', (e) => {
				gnavAction(e);
			});
		});
	}

	// 背景クリック
	if (overlay !== null) {
		overlay.addEventListener('click', (e) => {
			gnavAction(e);
		});
	}
};

const disableScroll = (el) => {

	const body = document.body;
	const className = 'is-scroll-disabled';

	// el.scrollTop = 1;

	window.addEventListener('touchmove', (event) =>  {
		if( document.body.classList.contains(className) && event.target === el ){
			event.preventDefault();
		} else {
			event.stopPropagation();
		}
	},{ passive: false });

	// if( body.classList.contains(className) ){
	// 	body.classList.remove(className);
	// } else {
	// 	body.classList.add(className);
	// }

};

/* 要素のフェードイン
---------------------------------------------------------- */
const inView = () => {
	const items = document.querySelectorAll('.js-inview');
	const isInview = 'is-inview';

	if (items.length < 1) return false;

	const cb = (entries, observer) => {
		entries.forEach((entry) => {

			const toggle = entry.target.dataset.inviewToggle;

			if (entry.isIntersecting) {

				entry.target.classList.add(isInview);

			} else {

				if ( toggle ) {
					entry.target.classList.remove(isInview)
				}

			}

		});
	};

	const options = {
		root: null,
		rootMargin: '0px 0px 0px 0px',
		threshold: [0.1]
	};

	const io = new IntersectionObserver(cb, options);

	items.forEach((item) => {
		io.observe(item);
	});

	const transitionLast = document.querySelectorAll('.transition-last');
	transitionLast.forEach(el => {
		const parent = el.parentElement;
		const next = parent.dataset.next;
		const nextEl = document.querySelector(`.${next}`);

		el.addEventListener('transitionend', () => {
			el.parentElement.classList.add('is-transitionend');

			if ( parent.classList.contains('is-inview') ) {
				if ( !next || next === 'hero-cost' && !isPc() ) return false;
				nextEl.classList.add('is-inview');
			}
		});
	});
};

/* splitText
---------------------------------------------------------- */
const splitText = () => {

	const targets = document.querySelectorAll('.js-split-text');
	const spanClass = 'split-text';

	const spanWrapText = (target, nodes) => {
		let spanWrapText = ""
		nodes.forEach((node, i) => {
			if (node.nodeType == 3) { // テキストの場合
				const text = node.textContent.replace(/\r?\n/g, ''); // テキストから改行コード削除
				// spanで囲んで連結
				spanWrapText = spanWrapText + text.split('').reduce((acc, v) => {
					return acc + `<span class="split-text">${v}</span>`
				}, "");
			} else { //テキスト以外
				// <br>などテキスト以外の要素をそのまま連結
				spanWrapText = spanWrapText + node.outerHTML
			}
		});
		target.innerHTML = spanWrapText;
	}

	targets.forEach( target => {
		const nodes = [...target.childNodes];
		const inners = target.querySelectorAll(spanClass);

		if ( inners ) {
			inners.forEach( inner => {
				const childNodes = [...inner.childNodes];
				spanWrapText(inner, childNodes);
			});
		}

		spanWrapText(target, nodes);

		const items = target.querySelectorAll(`.${spanClass}`);
		const length = items.length;

		items.forEach( (item, i) => {
			const delay = ( target.dataset.delay ) ? i * target.dataset.delay : i * 0.1 ;
			item.style.transitionDelay = `${delay}s`;

			if ( i+1 == length ) {
				item.classList.add(`${spanClass}--last`);
			}
		});

		const last = target.querySelectorAll(`.${spanClass}--last`);
		last.forEach( el => {
			el.addEventListener('transitionend', () => {
				if ( target.classList.contains('is-inview') ) {
					target.classList.add('is-transitionend');
				}
			});
		});

	});

}

/* アコーディオン
---------------------------------------------------------- */
const accordion = () => {

	const details = document.querySelectorAll(".js-details");
	const RUNNING_VALUE = "running";
	const IS_OPENED_CLASS = "is-opened";

	details.forEach((el) => {
		const summary = el.querySelector(".js-summary");
		const content = el.querySelector(".js-content");

		summary.addEventListener("click", (event) => {
			event.preventDefault();

			if (el.dataset.animStatus === RUNNING_VALUE) {
				return;
			}

			if (el.open) {

				el.classList.toggle(IS_OPENED_CLASS);

				const closingAnim = content.animate(closingAnimKeyframes(content), animTiming);
				el.dataset.animStatus = RUNNING_VALUE;

				closingAnim.onfinish = () => {
					el.removeAttribute("open");
					el.dataset.animStatus = "";
				};

			} else {

				el.setAttribute("open", "true");
				el.classList.toggle(IS_OPENED_CLASS);
				const openingAnim = content.animate(openingAnimKeyframes(content), animTiming);
				el.dataset.animStatus = RUNNING_VALUE;

				openingAnim.onfinish = () => {
					el.dataset.animStatus = "";
				};
			}
		});
	});

	const animTiming = {
		duration: 400,
		easing: "ease-out"
	};

	const closingAnimKeyframes = (content) => [
		{
			height: content.offsetHeight + 'px',
			// opacity: 1,
		}, {
			height: 0,
			// opacity: 0,
		}
	];

	const openingAnimKeyframes = (content) => [
		{
			height: 0,
			// opacity: 0,
		}, {
			height: content.offsetHeight + 'px',
			// opacity: 1,
		}
	];
}

//* slider
//---------------------------------------------------------- */
const slider = () => {

	Swiper.use([Navigation, Pagination]);

	const swiper = new Swiper('.swiper', {
		loop: true,
		slidesPerView: 1,
		spaceBetween: 20,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			768: {
				slidesPerView: 2.19,
				spaceBetween: 0,
			}
		}
	});

}

/* lenis
---------------------------------------------------------- */
const LenisFnc = () => {

	if ( !isPc() ) return false;

	const orientation = ( document.body.classList.contains('home-page') ) ? 'horizontal' : 'vertical';
	const lenis = new Lenis({
		orientation: orientation,
	});

	lenis.on('scroll', ScrollTrigger.update);

	function raf(time) {
		lenis.raf(time);
		requestAnimationFrame(raf);
	}
	requestAnimationFrame(raf);


	const smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');

	smoothScrollTrigger.forEach(target => {
		target.addEventListener('click', (e) => {
			e.preventDefault();
			const href = target.getAttribute('href');
			lenis.scrollTo(href)
		});
	});

}

/* cursorFollow
---------------------------------------------------------- */
const cursorFollow = () => {

	const ball = document.querySelector(".mouse");
	const pointer = document.querySelector(".mouse__pointer");
	const containers = document.querySelectorAll(".js-hover-cursor");
	const pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
	const mouse = { x: pos.x, y: pos.y };
	const speed = 0.2;
	const xSet = gsap.quickSetter(ball, "x", "px");
	const ySet = gsap.quickSetter(ball, "y", "px");

	if ( !containers ) return false;

	gsap.set(".mouse", { xPercent: -60, yPercent: -60 });

	window.addEventListener("mousemove", (e) => {
		mouse.x = e.x;
		mouse.y = e.y;
	});
	gsap.ticker.add(() => {
		// adjust speed for higher refresh monitors
		const dt = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio());
		pos.x += (mouse.x - pos.x) * dt;
		pos.y += (mouse.y - pos.y) * dt;
		xSet(pos.x);
		ySet(pos.y);
	});

	containers.forEach((container) => {
		container.addEventListener('mouseenter', (e) => {
			pointer.dataset.text = container.dataset.cursorText;
			pointer.dataset.style = container.dataset.cursorStyle;
			ball.classList.add('is-hover')
		});
		container.addEventListener('mouseleave', (e) => {
			ball.classList.remove('is-hover')
		});
	});

}

/* horizontalScroll
---------------------------------------------------------- */
const horizontalScroll = () => {

	const company = document.querySelector(".company-section__track");

	if ( !company ) return false;

	if ( isPc() ) {

		// COMPANY
		gsap.timeline({
			scrollTrigger: {
				trigger: company,
				// horizontal: true,
				horizontal: true,
				start: "left left",
				end: "right right",
				scrub: true
				//markers: true
			}
		})
		.to(".company-component", { xPercent: 100, ease: "none" });

		gsap.timeline({
			scrollTrigger: {
				trigger: company,
				horizontal: true,
				start: "10% left",
				end: "right right",
				scrub: true
				//toggleActions: "play none none reverse",
				//markers: true
			}
		})
		.to(".company-background-video", {
			width: "100%",
			height: "100%",
			marginTop: 0
		})
		.to(".company-background-overlay", {
			opacity: "0",
		}, '0');
		// .to(".company-section__content", {
		// 	opacity: "0",
		// }, '0');

		gsap.timeline({
			scrollTrigger: {
				trigger: company,
				horizontal: true,
				start: "50% left",
				end: "right left",
				scrub: true,
				// markers: true
			}
		})
		.fromTo(".company-background-video", { x: "0%" }, { x: "30%" });

		// bg
		gsap.timeline({
			scrollTrigger: {
				trigger: '.bg-01',
				endTrigger: ".company-section__figure",
				horizontal: true,
				start: "left left",
				end: "left right",
				scrub: true,
				pin: true,
				pinSpacing: false,
				// markers: true,
			}
		});

	} else {

		// COMPANY
		gsap.timeline({
			scrollTrigger: {
				trigger: company,
				start: "top top",
				end: "bottom bottom",
				scrub: true,
				pin: true,
				pinSpacing: false,
				// markers: true
			}
		})
		// .to(".company-component", { yPercent: 100, ease: "none" });

		gsap.timeline({
			scrollTrigger: {
				trigger: company,
				start: "top top",
				end: "bottom bottom",
				scrub: true,
				// markers: true
			}
		})
		.to(".company-background-video", {
			// width: "100%",
			// height: "100%",
			scale: 1,
			marginTop: 0
		})
		.to(".company-background-overlay", {
			opacity: "0",
		}, '0');
		// .to(".company-section__content", {
		// 	opacity: "0",
		// }, '0');

		gsap.timeline({
			scrollTrigger: {
				trigger: company,
				start: "50% top",
				end: "bottom top",
				scrub: true,
				// markers: true
			}
		})
		.fromTo(".company-background-video", { y: "0%" }, { y: "30%" });

	}

}

/* parallax
---------------------------------------------------------- */
const parallax = () => {

	const els = document.querySelectorAll('.js-parallax');
	const horizontal = ( document.body.classList.contains('home-page') && isPc() ) ? true : false;

	if ( els.length === 0 ) return false;

	els.forEach((el) => {
		const sp = el.dataset.parallaxSp;

		if ( !isPc() && sp === 'none' ) return false;

		let x = el.dataset.parallax || -100;
		let y = el.dataset.parallax || -100;

		if ( !isPc() ){
			y = y / 2.5;
			x = x / 2.5;
		}

		if ( horizontal === true || el.dataset.horizontal === 'true') {
			y = 0
		} else {
			x = 0;
		}

		gsap.fromTo(el, {
			x: 0,
			y: 0,
		}, {
			x: x,
			y: y,
			ease: "none",
			scrollTrigger: {
			trigger: el,
			horizontal: horizontal,
			start: "top bottom",
			end: "bottom top",
			scrub: 1,
			// markers: true,
			}
		});
	});

};

//* parallaxText
//---------------------------------------------------------- */
const parallaxText = () => {

	const elm = document.querySelectorAll('.js-parallax-text');

	if ( elm ) {

		elm.forEach(el => {

			const width = el.scrollWidth;
			const reverse = el.dataset.parallaxReverse;
			const adjust = ( isPc() ) ? 100 : 0 ;
			let x = ( reverse ) ? `${width - window.innerWidth + adjust}` : `-${width - window.innerWidth + adjust}`;

			if ( !isPc() ){
				x = x / 2;
			}

			console.log(x);

			gsap.to(el, {
				x: `${x}px`,
				scrollTrigger: {
					trigger: el,
					start: `top+=100 bottom`,
					end: "bottom top",
					scrub: 1,
					// markers: true,
				}
			});
		});

	}
};

//* scrollDown
//---------------------------------------------------------- */
const scrollDown = () => {

	const el = document.querySelector('.scroll-down');

	if ( el ) {

		gsap.to(el, {
			scrollTrigger: {
				trigger: el,
				start: `top top+=35.5%`,
				end: "bottom botom",
				endTrigger: 'html',
				// markers: true,
				toggleClass: { targets: el, className: 'is-fixed'},
			}
		});

	}
};

//* stcky-slider
//---------------------------------------------------------- */
const stckySlider = () => {

	const articles = document.querySelectorAll('.stcky-slider-item');
	const figure = document.querySelector('.stcky-slider__list');
	const image = document.querySelectorAll('.stcky-slider__slide');

	if ( articles.length > 1 ) {

		image[0].classList.add('is-active');

		articles.forEach((article, i) => {
			gsap.to(article, {
				scrollTrigger: {
					trigger: article,
					start: 'top 60%',
					end: 'bottom 60%',
					// toggleClass: { targets: image[i], className: 'is-active'},
					onEnter: (e) => {
						image[i].classList.add('is-active');
					},
					// onEnterBack: (e) => {

					// },
					// onLeave: () => {

					// },
					onLeaveBack: () => {
						if ( i === 0 ) return false;
						image[i].classList.remove('is-active');
					},
					// markers: true,
				}
			});
		});

	}

};

//* pageNav
//---------------------------------------------------------- */
const pageNav = () => {

	const sections = document.querySelectorAll('.horizontal-box');

	if ( sections.length > 1 ) {

		document.body.dataset.active = "intro";

		sections.forEach(el => {

			const id = el.getAttribute("id");
			const start = ( id === 'intro' ) ? "1% left" : "left left";

			gsap.timeline({
				scrollTrigger: {
					trigger: el,
					horizontal: true,
					start: start,
					end: "right right",
					// markers: true,
					onEnter: (e) => {
						document.body.dataset.active = e.trigger.getAttribute("id");
					},
					onLeaveBack: (e) => {
						document.body.dataset.active = e.trigger.getAttribute("id");
					},
				}
			});
		});

	}

}


/* loader
---------------------------------------------------------- */
const loader = () => {

	const isLoaded = new Event("isLoaded");
	const imagesLoaded = require('imagesloaded');
	const progressNumber = document.querySelector('.js-loader-progress-number')

	const imgLoad = imagesLoaded('body');//body内の画像を監視
	const imgTotal = imgLoad.images.length;//画像の総数を取得

	let imgLoaded = 0;//ロードした画像カウント
	let progressSpeed = 8;//プログレスバーの進むスピード 大きいほど速くなる
	let progressCount = 0;//ローディングの進捗状況 0〜100
	let progressResult = 0;//ローディングの進捗状況 0〜100

	//読み込み状況をアップデート
	let progressInit = setInterval(() => {
		updateProgress();
	}, 25);

	//画像を一つロードするたびにimgLoadedのカウントをアップ
	imgLoad.on('progress', (instance, image) => {
		imgLoaded++
	})

	const updateProgress = () => {

		//ローディング演出用の計算
		progressCount += (imgLoaded / imgTotal) * progressSpeed;

		if(progressCount >= 100 && imgTotal > imgLoaded) {
			//カウントは100以上だが画像の読み込みが終わってない
			progressResult = 99;
		} else if(progressCount > 99.9) {
			//カウントが100以上になった
			progressResult = 100;
		} else {
			//現在のカウント
			progressResult = progressCount;
		}

		//ローディング進捗状況をプログレスバーと数字で表示
		progressNumber.innerText = Math.floor(progressResult) + '%';

		//ローディング完了後 0.8秒待ってページを表示
		if (progressResult >= 100 && imgTotal == imgLoaded) {
			clearInterval(progressInit);
			setInterval(() => {
				document.body.classList.add('is-loaded');
				window.dispatchEvent(isLoaded);
			}, 500);
		}
	}

}

//* video
//---------------------------------------------------------- */
const video = () => {

	const elm = document.querySelectorAll('.js-video');

	elm.forEach((el) => {
		const video = el.querySelector('video');

		el.addEventListener('click', (e) => {
			el.classList.add('is-play')
			video.play();
		});
	});
}
/* setFillHeight
---------------------------------------------------------- */
const setFillHeight = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

let vw = window.innerWidth;

window.addEventListener('resize', () => {
  if (vw === window.innerWidth) {
  // 画面の横幅にサイズ変動がないので処理を終える
    return;
  }

  // 画面の横幅のサイズ変動があった時のみ高さを再計算する
  vw = window.innerWidth;
  setFillHeight();
});

/* resizeEnd
---------------------------------------------------------- */
const event = new CustomEvent('resizeend');
const currentWidth = window.innerWidth;
let timeoutID = 0;
let delay = 500;

window.addEventListener("resize", () => {

	if ( currentWidth === window.innerWidth ) return false;

	clearTimeout(timeoutID);
	timeoutID = setTimeout( () => {
		window.dispatchEvent(event);
	}, delay);

}, false);

/* mediaQuery
---------------------------------------------------------- */
const isPc = () => {

	const mq = ( window.matchMedia( "(min-width: 768px)" ).matches ) ? true : false;
	return mq;

}

loader();
webfont();
gnavToggle();
disableScroll();
splitText();
// accordion();
slider();
cursorFollow();
video();
setFillHeight();
LenisFnc();
horizontalScroll();
parallax();
parallaxText();
scrollDown()
stckySlider();
pageNav();

window.addEventListener("isLoaded", () => {
	inView();
});